import { callWebUtils } from "../../Actions";
import { ActionsCampaignsOverview } from "./ActionsCampaignsOverview";

export const ActionsListenersCampaignsOverview = () => {
  ActionsCampaignsOverview.getActiveCampaignCount.listen(function (organizationId) {
    return callWebUtils(this, "getActiveCampaignCount", [organizationId]);
  });

  ActionsCampaignsOverview.getActiveApplicantsCount.listen(function (organizationId) {
    return callWebUtils(this, "getActiveApplicantsCount", [organizationId]);
  });

  ActionsCampaignsOverview.getHelloMessage.listen(function (language) {
    return callWebUtils(this, "getHelloMessage", [language]);
  });
};
